export default __webpack_public_path__ + "static/media/2-Cloudxier-AdventureIndonesiaLogo.584c4d0c.png";